export default __webpack_public_path__ + "static/media/map-pin.65baece9.svg";